import Util from '../utils/util';
import Menu from './menu';

import { Packets } from '@kaetram/common/network';

import type Game from '../game';

const CLASS_KEYS: Record<string, string> = {
    'cp-guerrero': 'guerrero',
    'cp-mago': 'mago',
    'cp-arquero': 'arquero'
};

export default class ClassPanel extends Menu {
    public constructor(private game: Game) {
        super('#class-panel');

        for (let [id, cls] of Object.entries(CLASS_KEYS)) {
            document.querySelector(`#${id}`)?.addEventListener('click', () => {
                this.choose(cls);
            });
        }

        document.querySelector('#class-panel-close')?.addEventListener('click', () => {
            this.hide();
        });
    }

    private choose(cls: string): void {
        this.game.socket.send(Packets.Chat, [`/clase ${cls}`]);

        // Highlight selected
        document.querySelectorAll('.class-panel-btn').forEach((btn) => btn.classList.remove('selected'));
        document.querySelector(`#cp-${cls}`)?.classList.add('selected');

        setTimeout(() => this.hide(), 600);
    }

    public override show(
        _v1?: unknown, _v2?: unknown, _v3?: unknown,
        _v4?: unknown, _v5?: unknown, _v6?: unknown
    ): void {
        Util.fadeIn(this.container);
    }

    public override hide(): void {
        Util.fadeOut(this.container);
    }
}
